export const isRunningCypress = () =>
  typeof window !== 'undefined' &&
  window.location.hostname === 'localhost' &&
  navigator.userAgent.includes('Cypress') &&
  (window as any).Cypress;
